"use strict";

window.addEventListener('DOMContentLoaded', function (event) {
  var contactTrigger = document.querySelector('.service-details-hero__heading');
  if (contactTrigger != null) {
    contactTrigger.addEventListener("click", function () {
      var container = this.closest('.service-details-hero__contact-us');
      container.classList.toggle('open');
    });
    var htmlEle = document.getElementsByTagName('html')[0];
    //Click outside of menu or search
    htmlEle.addEventListener("click", function (e) {
      var el = $(e.target),
        $contactLinks = $(".service-details-hero__contact-us");
      if (el.is($contactLinks) || $contactLinks.has(el).length) {
        return true;
      } else {
        $contactLinks.removeClass("open");
      }
    });
  }
  var contactTriggerLeft = document.querySelector('.service-details-hero__heading-left');
  if (contactTriggerLeft != null) {
    contactTriggerLeft.addEventListener("click", function () {
      var container = this.closest('.service-details-hero__contact-us');
      container.classList.toggle('open');
    });
    var _htmlEle = document.getElementsByTagName('html')[0];
    //Click outside of menu or search
    _htmlEle.addEventListener("click", function (e) {
      var el = $(e.target),
        $contactLinks = $(".service-details-hero__contact-us");
      if (el.is($contactLinks) || $contactLinks.has(el).length) {
        return true;
      } else {
        $contactLinks.removeClass("open");
      }
    });
  }
});